import { format } from 'date-fns';
import { uk } from 'date-fns/locale';


export const Schedule = ({schedule}) => {

    const  today = format(new Date(), 'eeee', {locale: uk});


    const result = schedule.map((item, index) => {
        const day = Object.keys(item)[0];
        const hours = item[day];
        return (
          <tr key={index}>
            <td className={today.toLowerCase() === day.toLowerCase() ? 'fw-bold' : ''}>{day.charAt(0).toUpperCase() + day.slice(1)}</td>
            <td>{hours.start} - {hours.end}</td>
          </tr>
        );
    })

    return (
        <table className="ms-5 mt-2 mb-3">
            <tbody> 
                {result}
            </tbody>
        </table>
    )
}